import { useMemo } from 'react';
import Avatar from '@/atoms/avatars/Avatar';
import BaseColors from '@/atoms/colors/Base';
import Heading from '@/atoms/typography/Heading';
import RoleList from '@/organisms/roles/RoleList/RoleList';
import SurveysList from '@/organisms/surveys/SurveysList';
import TeamList from '@/organisms/teams/TeamList/TeamList';
import ViewMode from '@/shared/enums/ViewMode';
import { useUserRelatedEntities } from '@/shared/hooks';
import { avatarImage } from '@/shared/utils/profile';
import Size from '@enums/Size';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import useAuthStore from '@pkg/auth/useStore';
import { useUserContext } from '@/lib/accounts/users/UserProvider';
import { SurveyStatus } from '@/lib/enums';

const RestrictedDashboardLayout = () => {
  const { me } = useAuthStore();
  const { organisation } = useAuthStore();
  const { groups } = useUserRelatedEntities(true);
  const { surveys } = useUserContext();

  // We need to check this.
  const allowLinks = !organisation.is_restricted || !me.is_role_only;

  const openSurveys = useMemo(() => {
    const out = [];
    Object.values(surveys).forEach((survey) => {
      switch (survey.status) {
        case SurveyStatus.IN_PROGRESS:
        case SurveyStatus.NOT_STARTED:
          out.push(survey);
          break;
      }
    });
    return out;
  }, [surveys]);

  return (
    <Stack
      sx={{
        backgroundColor: BaseColors.background.secondary,
        color: BaseColors.font.primary,
        height: 'calc(100vh)',
      }}
    >
      <div
        style={{
          overflowX: 'hidden',
          overflowY: 'auto',
          scrollBehavior: 'smooth',
        }}
      >
        <Grid container direction="row" py={8} px={4} spacing={6}>
          <Grid item size={{ xs: 12, md: 9, lg: 6 }} offset={{ md: 2, lg: 3 }}>
            <Stack mb={2}>
              <Avatar
                name={`${me.first_name} ${me.last_name}`}
                size={Size.X_LARGE}
                src={avatarImage(me)}
              />
            </Stack>
            <Heading variant="h2" overrideStyles={{ mb: 0.5 }}>
              Hello <span style={{ fontWeight: 700 }}>{me?.first_name},</span>
            </Heading>
            <Heading variant="h3">Welcome back to Beamible!</Heading>
          </Grid>
          <Grid item size={{ xs: 12, md: 9, lg: 6 }} offset={{ md: 2, lg: 3 }}>
            <SurveysList surveys={openSurveys} />
          </Grid>
          <Grid item size={{ xs: 12, md: 9, lg: 6 }} offset={{ md: 2, lg: 3 }}>
            <RoleList allowLinks={allowLinks} viewMode={ViewMode.INSIGHTS} />
          </Grid>
          {groups?.length > 0 && (
            <Grid
              item
              size={{ xs: 12, md: 9, lg: 6 }}
              offset={{ md: 2, lg: 3 }}
            >
              <TeamList viewMode={ViewMode.INSIGHTS} />
            </Grid>
          )}
        </Grid>
      </div>
    </Stack>
  );
};

export default RestrictedDashboardLayout;
